import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/shared/services/alert.service';
import { EventEmitterService } from '@app/shared/services/eventemitter.service';
import { LoaderService } from '@app/shared/services/loader.service';
import { ToastrService } from 'ngx-toastr';
import { ServicesListComponent } from '../services-list.component';
import { ReleaseMgmtService } from '@app/shared/services/releaseMgmtService';
import { ripple, textField, formField } from 'material-components-web';
import { ConstantsService } from '@app/common/constants.service';
import { CSListDto } from '@app/apiModules/CSList';
import { firstValueFrom } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

export enum ServiceStatus {
  Inactive = 0,
  Active = 1,
  InactiveForFutureRelease = 2
}

@Component({
  standalone: true,
  selector: 'app-add-modify-service-config',
  templateUrl: './add-modify-service-config.component.html',
  styleUrls: ['./add-modify-service-config.component.scss'],
  imports: [CommonModule, MatTooltipModule, MatIconModule, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, MatSelectModule]
})
export class AddModifyServiceConfigComponent {
  serviceForm: UntypedFormGroup;
  @Input() allServices: CSListDto[];
  @Input() public data: CSListDto;

  @Output("closeSlider") closeSlider: EventEmitter<any> = new EventEmitter();
  @Output() selectedChange = new EventEmitter<any>();
  @ViewChild('submitButton') submitButton: ElementRef;
  submitted = false;
  selectedPermissions: any;
  configserviceNameInfoMsg = "Allowed: letters, numbers, hyphens, spaces, and underscores. Maximum length: 150 characters.";
  configGitRepoNameInfoMsg = "Allowed: letters, numbers, periods, hyphens, and underscores. Maximum length: 256 characters.";
  configgitHubDefaultBranchNameInfoMsg = "Default branch is 'master'. Maximum length: 100 characters.";

  hasAllVisibility: boolean;
  filterText: 'Filter';
  rows: string[];
  buttonClasses = [
    'btn-outline-primary',
    'btn-outline-secondary',
    'btn-outline-success',
    'btn-outline-danger',
    'btn-outline-warning',
    'btn-outline-info',
    'btn-outline-light',
    'btn-outline-dark'
  ];
  buttonClass = this.buttonClasses[0];
  availableConfigurations: string[] = ["API", "Web"];
  loading: boolean;
  IsReadOnly: boolean = false;
  isServiceReleaseExists: boolean = false;
  showInactiveForFutureRelease: boolean = true; // Set this based on release context
  previousStatus: number;
  get f() { return this.serviceForm.controls; }
  constructor(
    public ReleaseMgmtService: ReleaseMgmtService,
    private servicesListComponent: ServicesListComponent,
    public alertService: AlertService, // Service for managing alerts
    public loader: LoaderService,
    public eventService: EventEmitterService,
    public formBuilder: UntypedFormBuilder,
    public loaderService: LoaderService,
    public toastr: ToastrService,
    public constantService: ConstantsService,
    public cdr: ChangeDetectorRef) {
  }
  ngOnInit() {

    this.serviceForm = this.formBuilder.group({
      id: [null],
      serviceName: [
        null,
        [
          Validators.required, Validators.pattern(/^[a-zA-Z0-9 \-_]+$/), // Allow alphabets, numbers, and hyphen space
          Validators.maxLength(50)
        ]
      ],
      gitHubRepositoryName: [
        null,
        [Validators.required, Validators.pattern(/^[a-zA-Z0-9._\-]+$/), // Allow a-z, A-Z, 0-9, period, hyphen, underscore
          Validators.maxLength(256)
        ] 
      ],
      gitHubDefaultBranchName: [{ value: 'master', disabled: true }, Validators.required, Validators.maxLength(100)],
      configuration: [[], Validators.required],
      status: [], // Not required, no Validators.required
    });
    this.closeEvent();
  }
  validateServiceName() {
    if (this.allServices) {
      const serviceName = this.serviceForm.get('serviceName')?.value;
      if (serviceName) {
        if (this.allServices && this.allServices.some(s => s.serviceName?.toLowerCase() === serviceName.toLowerCase())) {
          this.toastr.error("Service name already exists", "Error");
          this.serviceForm.get('serviceName')?.setErrors({ 'duplicate': true });
          return;
        }
      }
    }

  }
  validateGitHubRepositoryName() {
    if (this.allServices) {
      const gitHubRepositoryName = this.serviceForm.get('gitHubRepositoryName')?.value;
      if (gitHubRepositoryName) {
        if (this.allServices && this.allServices.some(s => s.gitHubRepositoryName?.toLowerCase() === gitHubRepositoryName.toLowerCase())) {
          this.toastr.error("GitHub Repository Name already exists", "Error");
          this.serviceForm.get('gitHubRepositoryName')?.setErrors({ 'duplicate': true });
          return;
        }
      }
    }

  }
  ngOnChanges(_changes: SimpleChanges) {
    if (this.data) {
      this.setLoader();
      setTimeout(() => {
        firstValueFrom(this.ReleaseMgmtService.apiGetServiceDataById(this.data.id)).then((res) => {
          if (res && res.id) {
            this.serviceForm.get('id').setValue(res.id);
            this.serviceForm.get('serviceName').setValue(res.serviceName);
            this.serviceForm.get('gitHubRepositoryName').setValue(res.gitHubRepositoryName);
            this.serviceForm.get('gitHubDefaultBranchName').setValue(res.gitHubDefaultBranchName);
            const configuration=[];
            if(res.hasAPI){
              configuration.push("API")
            }
            if(res.hasWeb){
              configuration.push("Web")
            }
            this.serviceForm.get('configuration').setValue(configuration);
            this.serviceForm.get('status').setValue(res.status);
            //Set Local Variables
            this.isServiceReleaseExists = res.isServiceReleaseExists ? res.isServiceReleaseExists : false;
            // this.getFormInvalidReason();
          }

          this.setUnLoader();

        });
        this.IsReadOnly = true;
      }, 1000);
      this.setUnLoader();

    }


  }
  IsNullOrEmpty(value: any): boolean {
    if (value === null || value === undefined || value === '') {
      return true;
    }
    return false;
  }
  /* istanbul ignore next */
  initMatComponent() {
    [].forEach.call(document.querySelectorAll('.text-material'), function (element) {
      if (element && element.querySelector('.mdc-text-field__input')) {
        textField.MDCTextField.attachTo(element);
      }
    });

    [].map.call(document.querySelectorAll('.ripple-material'), function (el) {
      ripple.MDCRipple.attachTo(el);
    });
  }
  /* istanbul ignore next */
  ngAfterViewInit() {
    setTimeout(() => {
      [].forEach.call(document.querySelectorAll('.text-material'), function (element) {
        if (element && element.querySelector('.mdc-text-field__input')) {
          textField.MDCTextField.attachTo(element);
        }
      });
      [].forEach.call(document.querySelectorAll('.ripple-material'), function (el) {
        if (el) {
          ripple.MDCRipple.attachTo(el);
        }
      });
      [].forEach.call(document.querySelectorAll('.formfield-material'), function (elem) {
        if (elem) {
          formField.MDCFormField.attachTo(elem);
        }
      });
    }, 2000);
  }
  // omit special characters on paste
  /* istanbul ignore next */
  on_paste_omit_special_char(event: ClipboardEvent, control, addtionalCharAllowed: number[] = []) {
    // local variables
    let clipboardData = event.clipboardData;
    let filteredText = '';

    // get text
    let pastedText = clipboardData.getData('text');
    let k;

    // loop to check for every char
    for (let i = 0; i < pastedText.length; i++) {
      k = pastedText.charCodeAt(i);
      if ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || addtionalCharAllowed.includes(k)  || (k >= 48 && k <= 57)) {
        filteredText += pastedText.charAt(i)
      }
    }

    const inputElem = event.target as HTMLInputElement;
    const formControl = this.serviceForm.controls[control];
    let value = formControl.value || '';
    let selectionStart = inputElem.selectionStart || 0;
    let selectionEnd = inputElem.selectionEnd || 0;

    // Insert filteredText at the cursor position, replacing any selected text
    let newValue = value.substring(0, selectionStart) + filteredText + value.substring(selectionEnd);

    // Respect maxLength if set on the control
    let maxLength = null;
    if (formControl.validator) {
      const testVal = formControl.validator({} as any);
      if (testVal && testVal.maxlength && typeof testVal.maxlength.requiredLength === 'number') {
        maxLength = testVal.maxlength.requiredLength;
      }
    }
    // If maxLength is not found via validator, try to get it from native element if available
    if (!maxLength && inputElem && inputElem.maxLength && inputElem.maxLength > 0) {
      maxLength = inputElem.maxLength;
    }
    if (maxLength) {
      newValue = newValue.substring(0, maxLength);
    }
    formControl.setValue(newValue);

    // Set cursor position after the pasted text
    setTimeout(() => {
      const pos = selectionStart + filteredText.length;
      inputElem.setSelectionRange(pos, pos);
    });

    // Prevent default paste
    return false;
  }

  // omit special characters
    /* istanbul ignore next */
  omit_special_char(event, isAlphaNumeric: boolean, addtionalCharAllowed: number[] = []) {
    let k;
    // get char code
    k = event.charCode;

    if (isAlphaNumeric) {
      // allowed only Alphabets, numbers & hyphen
      return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || addtionalCharAllowed.includes(k)  || (k >= 48 && k <= 57));
    }
    else {
      // allowed only number & full stop
      return (k == 46 || (k >= 48 && k <= 57));
    }
  }

  OnConfigurationChange(){
    const configurations=this.serviceForm.get('configuration').value;
    const hasAPI =  configurations.includes("API");
    const hasWeb = configurations.includes("Web");
    if (this.data && this.isServiceReleaseExists === true) {
      if ((this.data.hasAPI && this.data.hasAPI !== hasAPI) || (this.data.hasWeb && this.data.hasWeb !== hasWeb)) {
        let mappingType = '';
        if (this.data.hasAPI && this.data.hasWeb) {
          mappingType = 'API & Web';
        } else if (this.data.hasAPI) {
          mappingType = 'API';
        } else if (this.data.hasWeb) {
          mappingType = 'Web';
        } else {
          mappingType = 'None';
        }
        this.toastr.warning(`Unable to Save! The component is already mapped to a release (${mappingType})`, '');
        this.submitButton.nativeElement.disabled = true;
      }
      else if (!(hasAPI || hasWeb)) {
        this.submitButton.nativeElement.disabled = true;
      }
      else {
        this.submitButton.nativeElement.disabled = false;
      }
    }
    else if (this.data && this.isServiceReleaseExists === false) {
       if (!(hasAPI || hasWeb)) {
        this.submitButton.nativeElement.disabled = true;
      }
      else {
        this.submitButton.nativeElement.disabled = false;
      }
    }
  }
  close() {
    this.submitted = false;
    this.serviceForm.reset();
    this.serviceForm.patchValue({ gitHubDefaultBranchName: 'master' });
    this.closeSlider.emit();
  }
      /* istanbul ignore next */
  closeEvent() {
    this.eventService.events$.forEach(_event => {

      this.close();
    });
  }
  save() {
    this.submitted = true;
    this.serviceForm.value.status = this.serviceForm.controls['status'].value;
    this.submitButton.nativeElement.disabled = true;
    const configurations=this.serviceForm.get('configuration').value;
    const hasAPI =  configurations.includes("API");
    const hasWeb = configurations.includes("Web");
    const serviceForm = JSON.parse(JSON.stringify(this.serviceForm.value));
    serviceForm.gitHubDefaultBranchName = this.serviceForm.get('gitHubDefaultBranchName').value
    serviceForm.hasAPI=hasAPI;
    serviceForm.hasWeb=hasWeb; 
    serviceForm.configuration=undefined;
    //FOR EDIT DATA
    if (this.data && this.data.id) {
      //FOR INACTIVE SERVICE
      if (
        (this.serviceForm.controls['status'].value == ServiceStatus.Inactive
          || this.serviceForm.controls['status'].value == ServiceStatus.InactiveForFutureRelease
        )
         &&
        Number(this.data.status) == ServiceStatus.Active
      ) {
        this.alertService.buildDialog().fire({
          title: "Are you sure?",
          text: "Inactive Service wont be available for New releases. Do you want to continue?",
          icon: this.alertService.WarningIcon,
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
        }).then((result) => {
          if (result.isConfirmed) {
            this.setLoader();
            this.ReleaseMgmtService.apiUpdateServiceConfigDetails(serviceForm)
              .subscribe({
                next: (res) => {
                  this.closeSlider.emit();
                  if (res) {
                    this.toastr.success("Service inactivated successfully", "");
                  }
                },
                error: (_error) => {
                  this.alertService.buildDialog().fire({
                    title: "Error",
                    text: "",
                    icon: this.alertService.ErrorIcon,
                    showCancelButton: false,
                    confirmButtonText: "OK",
                    cancelButtonText: "",
                  });
                  this.clearForm();
                  this.closeSlider.emit();
                }
              });
            this.setUnLoader();
          } else {
            this.setUnLoader();
            this.submitButton.nativeElement.disabled = false;
          }
        });
        return;
      }
      else {
        const onlyStatusChanged =
          serviceForm.serviceName === this.data.serviceName &&
          serviceForm.gitHubRepositoryName === this.data.gitHubRepositoryName &&
          // formValue.gitHubDefaultBranchName === this.data.gitHubDefaultBranchName &&
          serviceForm.hasAPI === this.data.hasAPI &&
          serviceForm.hasWeb === this.data.hasWeb &&
          serviceForm.status === ServiceStatus.Active &&
          Number(this.data.status) === ServiceStatus.Inactive;
        //FOR ACTIVE SERVICE
        if (onlyStatusChanged) {
          this.setLoader();
          this.ReleaseMgmtService.apiUpdateServiceConfigDetails(serviceForm)
            .subscribe({
              next: (res) => {
                this.closeSlider.emit();
                if (res) {
                  this.toastr.success("Service Activated successfully", "");
                }
              },
              error: (_error) => {
                this.alertService.buildDialog().fire({
                  title: "Error",
                  text: "",
                  icon: this.alertService.ErrorIcon,
                  showCancelButton: false,
                  confirmButtonText: "OK",
                  cancelButtonText: "",
                });
                this.clearForm();
                this.closeSlider.emit();
              }
            });
          this.setUnLoader();
        }
        //FOR UPDATE SERVICE
        else {
          this.setLoader();
          this.ReleaseMgmtService.apiUpdateServiceConfigDetails(serviceForm)
            .subscribe(
              {
                next: (res) => {
                  this.closeSlider.emit();
                  if (res) {
                    let toastMsg = "";
                    toastMsg = "Service Updated successfully";
                    this.toastr.success(toastMsg, "");
                  }
                },
                error: (_error) => {
                  console.log(_error);

                  this.alertService.buildDialog().fire({
                    title: "Error",
                    text: "",
                    icon: this.alertService.ErrorIcon,
                    showCancelButton: false,
                    confirmButtonText: "OK",
                    cancelButtonText: "",
                  });
                  this.clearForm();
                  this.closeSlider.emit();
                }
              });
          this.setUnLoader();
        }
        return;
      }

    } else {
      this.setLoader();
      serviceForm.id=undefined;
      this.ReleaseMgmtService.apiSaveServiceConfigDetails(serviceForm)
        .subscribe(
          {
            next: (res) => {
              this.closeSlider.emit();
              if (res) {
                let toastMsg = "";
                toastMsg = "Service Added Successfully";
                this.toastr.success(toastMsg, "");
              }
            },
            error: (_error) => {
              this.alertService.buildDialog().fire({
                title: "Error",
                text: _error.error.error.message,
                icon: this.alertService.ErrorIcon,
                showCancelButton: false,
                confirmButtonText: "OK",
                cancelButtonText: "",
              });
              this.clearForm();
              this.closeSlider.emit();
            }
          });
      this.setUnLoader();

    }

  }

  clearForm() {
    this.submitted = false;
    this.serviceForm.reset();
    this.serviceForm.patchValue({ gitHubDefaultBranchName: 'master' });
  }

  setLoader() {
    this.loading = true;
    this.loaderService.showSpinner.next(true);
  }
  setUnLoader() {
    this.loading = false;
    this.loaderService.showSpinner.next(false);
  }

  noop() { } // no-operation empty event 

}
